function antiForgeryToken() {
    var service = window && window.$ && window.$.ServicesFramework && window.$.ServicesFramework();

    return service && service.getAntiForgeryValue() ? service.getAntiForgeryValue() : '';
}

function portexaLogTemplateSettingsWarning(message, detail) {
    if (!window.console || !window.console.warn) {
        return;
    }

    if (detail) {
        window.console.warn('[Portexa] OpenContent template settings skipped: ' + message, detail);
    } else {
        window.console.warn('[Portexa] OpenContent template settings skipped: ' + message);
    }
}

function portexaTryParseJson(text) {
    try {
        return {
            success: true,
            data: JSON.parse(text)
        };
    } catch (error) {
        return {
            success: false,
            error: error
        };
    }
}

function portexaHideTemplateElements(hiddenTemplates) {
    if (!hiddenTemplates || !hiddenTemplates.length) {
        return;
    }

    hiddenTemplates.forEach(function (title) {
        var templateLinks;
        var options;

        if (!title) {
            return;
        }

        /*
         * Avoid building a dynamic selector like:
         * .octemplate a[title='...']
         *
         * Template names can include characters that break querySelectorAll().
         */
        templateLinks = document.querySelectorAll('.octemplate a');

        templateLinks.forEach(function (element) {
            if (element.getAttribute('title') === title && element.parentElement) {
                element.parentElement.style.display = 'none';
            }
        });

        options = document.querySelectorAll('select option');

        options.forEach(function (option) {
            if (option.textContent === title) {
                option.style.display = 'none';
            }
        });
    });

    document.querySelectorAll('select').forEach(function (select) {
        var selectedOption = select.selectedOptions && select.selectedOptions[0];
        var i;

        if (selectedOption && selectedOption.style.display === 'none') {
            select.selectedIndex = -1;

            for (i = 0; i < select.options.length; i++) {
                if (select.options[i].style.display !== 'none') {
                    select.selectedIndex = i;
                    break;
                }
            }
        }
    });
}

function portexaInitializeTemplateVisibility(jsonObj) {
    var applyVisibilityRules;
    var observer;

    if (!jsonObj || !jsonObj.Modules || !Array.isArray(jsonObj.Modules)) {
        portexaLogTemplateSettingsWarning('Endpoint returned JSON, but it did not include a Modules array.', jsonObj);
        return;
    }

    if (!jsonObj.Modules.length) {
        return;
    }

    applyVisibilityRules = function () {
        try {
            portexaHideTemplateElements(jsonObj.Modules);
        } catch (error) {
            portexaLogTemplateSettingsWarning('Unable to apply template visibility rules.', error);
        }
    };

    if (window.MutationObserver && document.body) {
        observer = new MutationObserver(function (mutations) {
            var shouldApplyRules = false;

            mutations.forEach(function (mutation) {
                if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                    shouldApplyRules = true;
                }
            });

            if (shouldApplyRules) {
                applyVisibilityRules();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    applyVisibilityRules();
}

function portexaLoadTemplateSettings() {
    var token;
    var endpoint;

    if (!window.fetch) {
        portexaLogTemplateSettingsWarning('The Fetch API is not available in this browser.');
        return;
    }

    token = antiForgeryToken();
    endpoint = window.location.origin + '/API/PortexaApiCore/OpenContentManageApi/GetTemplatesSettings';

    fetch(endpoint, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Accept': 'application/json',
            'RequestVerificationToken': token
        }
    })
        .then(function (response) {
            if (!response.ok) {
                portexaLogTemplateSettingsWarning('Endpoint returned HTTP ' + response.status + ' ' + response.statusText + '.', {
                    url: endpoint,
                    status: response.status,
                    statusText: response.statusText
                });

                return null;
            }

            return response.text().then(function (text) {
                var contentType;
                var parsed;

                if (!text) {
                    portexaLogTemplateSettingsWarning('Endpoint returned an empty response.');
                    return null;
                }

                contentType = response.headers && response.headers.get ? response.headers.get('content-type') : '';

                if (contentType && contentType.indexOf('application/json') === -1) {
                    portexaLogTemplateSettingsWarning('Endpoint did not return JSON.', {
                        contentType: contentType,
                        responseStart: text.substring(0, 120)
                    });

                    return null;
                }

                parsed = portexaTryParseJson(text);

                if (!parsed.success) {
                    portexaLogTemplateSettingsWarning('Endpoint returned invalid JSON.', {
                        error: parsed.error,
                        responseStart: text.substring(0, 120)
                    });

                    return null;
                }

                return parsed.data;
            });
        })
        .then(function (jsonObj) {
            if (!jsonObj) {
                return;
            }

            portexaInitializeTemplateVisibility(jsonObj);
        })
        .catch(function (error) {
            portexaLogTemplateSettingsWarning('Request failed before template settings could be loaded.', error);
        });
}


function portexaLogBootstrapWarning(message, detail) {
    if (!window.console || !window.console.warn) {
        return;
    }

    if (detail) {
        window.console.warn('[Portexa] Bootstrap component initialization skipped: ' + message, detail);
    } else {
        window.console.warn('[Portexa] Bootstrap component initialization skipped: ' + message);
    }
}

function portexaInitializeBootstrapComponentSet(root) {
    var bootstrapApi = window.bootstrap;
    var container = root && root.querySelectorAll ? root : document;
    var componentSelectors;

    if (!bootstrapApi) {
        portexaLogBootstrapWarning('The Bootstrap JavaScript API is not available yet.');
        return;
    }

    componentSelectors = [
        {
            selector: '[data-bs-toggle="tooltip"]',
            constructorName: 'Tooltip',
            options: {
                container: 'body',
                trigger: 'hover focus'
            }
        },
        {
            selector: '[data-bs-toggle="popover"]',
            constructorName: 'Popover',
            options: {
                container: 'body',
                trigger: 'click',
                html: false
            }
        },
        {
            selector: '[data-bs-toggle="dropdown"]',
            constructorName: 'Dropdown',
            options: {}
        },
        {
            selector: '[data-bs-toggle="collapse"]',
            constructorName: 'Collapse',
            options: {
                toggle: false
            }
        },
        {
            selector: '[data-bs-toggle="modal"]',
            constructorName: 'Modal',
            options: {}
        },
        {
            selector: '[data-bs-toggle="offcanvas"]',
            constructorName: 'Offcanvas',
            options: {}
        },
        {
            selector: '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [role="tab"][data-bs-target], [role="tab"][href^="#"]:not([href="#"])',
            constructorName: 'Tab',
            options: {}
        },
        {
            selector: '.toast',
            constructorName: 'Toast',
            options: {}
        },
        {
            selector: '.carousel',
            constructorName: 'Carousel',
            options: {}
        },
        {
            selector: '[data-bs-spy="scroll"]',
            constructorName: 'ScrollSpy',
            options: {}
        }
    ];

    componentSelectors.forEach(function (component) {
        var Constructor = bootstrapApi[component.constructorName];

        if (!Constructor) {
            return;
        }

        container.querySelectorAll(component.selector).forEach(function (element) {
            try {
                if (Constructor.getOrCreateInstance) {
                    Constructor.getOrCreateInstance(element, component.options);
                } else if (!Constructor.getInstance || !Constructor.getInstance(element)) {
                    new Constructor(element, component.options);
                }

                if (component.constructorName === 'Toast' && element.getAttribute('data-bs-autoshow') === 'true') {
                    Constructor.getOrCreateInstance(element).show();
                }
            } catch (error) {
                portexaLogBootstrapWarning('Unable to initialize ' + component.constructorName + '.', {
                    element: element,
                    error: error
                });
            }
        });
    });
}


function portexaHandleTabFallbackClick(event) {
    var clicked = event.target && event.target.closest ? event.target.closest('.nav-tabs .nav-link, .nav-pills .nav-link') : null;
    var nav;
    var targetSelector;
    var targetPane;

    if (!clicked || clicked.classList.contains('disabled') || clicked.getAttribute('aria-disabled') === 'true') {
        return;
    }

    if (clicked.getAttribute('data-bs-toggle') === 'tab' || clicked.getAttribute('data-bs-toggle') === 'pill') {
        return;
    }

    nav = clicked.closest('.nav-tabs, .nav-pills');

    if (!nav) {
        return;
    }

    targetSelector = clicked.getAttribute('data-bs-target') || clicked.getAttribute('href');

    if (targetSelector && targetSelector !== '#' && targetSelector.charAt(0) === '#') {
        try {
            targetPane = document.querySelector(targetSelector);
        } catch (error) {
            targetPane = null;
        }
    }

    event.preventDefault();

    nav.querySelectorAll('.nav-link').forEach(function (link) {
        var panelSelector = link.getAttribute('data-bs-target') || link.getAttribute('href');
        var panel = null;

        link.classList.remove('active');
        link.setAttribute('aria-selected', 'false');

        if (panelSelector && panelSelector !== '#' && panelSelector.charAt(0) === '#') {
            try {
                panel = document.querySelector(panelSelector);
            } catch (error) {
                panel = null;
            }
        }

        if (panel && panel.classList.contains('tab-pane')) {
            panel.classList.remove('active', 'show');
        }
    });

    clicked.classList.add('active');
    clicked.setAttribute('aria-selected', 'true');

    if (targetPane && targetPane.classList.contains('tab-pane')) {
        targetPane.classList.add('active', 'show');
    }
}

function portexaInitializeBootstrapFallbacks() {
    if (document.documentElement.getAttribute('data-portexa-bootstrap-fallbacks') === 'true') {
        return;
    }

    document.documentElement.setAttribute('data-portexa-bootstrap-fallbacks', 'true');
    document.addEventListener('click', portexaHandleTabFallbackClick, false);
}

function portexaInitializeBootstrapComponents() {
    var observer;
    var pending = false;

    portexaInitializeBootstrapComponentSet(document);

    if (!window.MutationObserver || !document.body) {
        return;
    }

    observer = new MutationObserver(function (mutations) {
        var shouldInitialize = false;

        mutations.forEach(function (mutation) {
            if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                shouldInitialize = true;
            }
        });

        if (!shouldInitialize || pending) {
            return;
        }

        pending = true;

        window.setTimeout(function () {
            pending = false;
            portexaInitializeBootstrapComponentSet(document);
        }, 100);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

document.addEventListener('DOMContentLoaded', function () {
    try {
        portexaInitializeBootstrapFallbacks();
        portexaInitializeBootstrapComponents();
    } catch (error) {
        portexaLogBootstrapWarning('Unexpected startup error.', error);
    }

    try {
        portexaLoadTemplateSettings();
    } catch (error) {
        portexaLogTemplateSettingsWarning('Unexpected startup error.', error);
    }
});